import { Box, Theme } from '@mui/material';
import classNames from 'classnames';
import { FC, ReactNode } from 'react';
import { createUseStyles } from 'react-jss';

interface Props {
  children: ReactNode;
  disabled?: boolean;
}

const useStyles = createUseStyles((theme: Theme) => ({
  title: {
    color: theme.palette.secondary.main,
    paddingBottom: 16,
    borderBottom: `1px solid ${theme.palette.divider}`,
    '&.disabled': {
      color: theme.palette.darkGray,
      borderBottomColor: theme.palette.gray,
    },
  },
}));

const PanelTitle: FC<Props> = ({ children, disabled = false }) => {
  const styles = useStyles();
  const compClass = classNames(styles.title, { disabled });

  return (
    <Box className={compClass} px={2.5} pt={2}>
      {children}
    </Box>
  );
};

export default PanelTitle;
